import React, { useState } from 'react';
import GlassCard from '../../../shared/components/card/GlassCard';
import ChangePasswordForm from '../components/ChangePasswordForm';
import '../../../styles/LoginForm.css'; // Reutilizamos los mismos estilos

const ChangePasswordPage = ({requireOldPassword = false}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ 
    newPassword: '', 
    confirmPassword: '' 
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [shake, setShake] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Usar función en lugar de valor directo
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value
    }));
    
    console.log("change", name, value);
    if (error) setError('');
    if (success) setSuccess('');
  };

  const validatePasswords = () => {
    if (formData.newPassword.length < 8) {
      return 'La contraseña debe tener al menos 8 caracteres.';
    }
    if (formData.newPassword !== formData.confirmPassword) {
      return 'Las contraseñas no coinciden.';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationError = validatePasswords();
    if (validationError) {
      setError(validationError);
      setShake(true);
      setTimeout(() => setShake(false), 2000);
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      // Aquí llamas a tu API para cambiar la contraseña
      // await changePasswordAPI(formData.newPassword);
      
      // Simulación de éxito (reemplazar con llamada real)
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setSuccess('Contraseña actualizada correctamente.');
      setFormData({ newPassword: '', confirmPassword: '' });
      
    } catch (err) {
      setError(getErrorMessage(err));
      setShake(true);
      setTimeout(() => setShake(false), 2000);
    } finally {
      setIsLoading(false);
    }
  };

  const getErrorMessage = (err) => {
    const statusCode = err?.response?.status;
    const serverMessage = err?.response?.data?.message;
    const errorCode = err?.code;

    if (serverMessage) return serverMessage;

    switch (statusCode) {
      case 400:
        return 'Datos inválidos. Verifica las contraseñas.';
      case 401:
        return 'Sesión expirada. Inicia sesión nuevamente.';
      case 403:
        return 'No tienes permisos para realizar esta acción.';
      case 409:
        return 'La nueva contraseña no puede ser igual a la anterior.';
      case 422:
        return 'La contraseña no cumple con los requisitos de seguridad.';
      case 500:
        return 'Error del servidor. Intenta más tarde.';
      default:
        break;
    }

    switch (errorCode) {
      case 'ECONNABORTED':
      case 'TIMEOUT':
        return 'Tiempo de espera agotado. Revisa tu conexión.';
      case 'NETWORK_ERROR':
      case 'ERR_NETWORK':
        return 'Sin conexión a internet.';
      default:
        break;
    }

    return 'Error al cambiar la contraseña. Intenta de nuevo.';
  };

  return (
    <div className="minimal-container">
      <GlassCard>
        <ChangePasswordForm
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          error={error}
          success={success}
          shake={shake}
          requireOldPassword={requireOldPassword}
        />
      </GlassCard>
    </div>
  );
};

export default ChangePasswordPage;